import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    activeClasses:   { type: String, default: "bg-white text-fg shadow-sm" },
    inactiveClasses: { type: String, default: "text-fg-muted" }
  }

  select({ params: { panel } }) {
    const active   = this.activeClassesValue.split(" ").filter(Boolean)
    const inactive = this.inactiveClassesValue.split(" ").filter(Boolean)

    this.panelTargets.forEach(p => {
      p.classList.toggle("hidden", p.dataset.tabsName !== panel)
    })

    this.tabTargets.forEach(t => {
      const isActive = t.dataset.tabsPanelParam === panel
      active.forEach(c   => t.classList.toggle(c, isActive))
      inactive.forEach(c => t.classList.toggle(c, !isActive))
    })
  }
}
